import { Dimensions, PixelRatio } from "react-native";

const HEADER_FONT_SIZE = PixelRatio.get() < 2 ? 20 : 30;
const SUB_HEADER_FONT_SIZE = PixelRatio.get() < 2 ? 15 : 20;
const INPUT_FONT_SIZE = PixelRatio.get() < 2 ? 25 : 35;

export const formScreen = {
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
  },
  imageContainer: {
    marginLeft: -5,
    width: Dimensions.get("window").width + 20,
    height: Dimensions.get("window").height + 100,
  },
  containerForm: {
    flex: 1,
    paddingTop: 60,
    width: "100%",
    alignItems: "center",
    backgroundColor: "#aa000000",
    paddingBottom: 50,
  },
  containerButton: {
    position: "absolute",
    width: "100%",
    bottom: 0,
  },
  textHeader1: {
    fontFamily: "Montserrat-Medium",
    color: "#F1F1F1",
    fontSize: HEADER_FONT_SIZE,
    marginTop: 10,
    marginBottom: 10,
    textAlign: "center",
    textShadowColor: "black",
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 5,
  },
  textHeader2: {
    fontFamily: "Montserrat",
    color: "#F1F1F1",
    fontSize: SUB_HEADER_FONT_SIZE,
    marginBottom: 8,
    textAlign: "center",
  },
  input: {
    fontFamily: "Montserrat",
    textAlign: "center",
    color: "#fff",
    width: "95%",
    padding: 5,
    alignSelf: "center",
    paddingBottom: 0,
    fontSize: INPUT_FONT_SIZE,
    borderBottomColor: "#CCC",
    borderBottomWidth: 1,
  },
  link: {
    fontFamily: "Montserrat",
    fontSize: 20,
    color: "#bbb",
    marginTop: 30,
    textDecorationLine: "underline",
  },
  iconClose: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: 8,
    paddingTop: 32,
  },
  iconToggle: {
    paddingLeft: 10,
  },
};
